import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'fi-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor, OnChanges, AfterViewInit {
  @Input() hint?: string;
  @Input() error?: string;
  @Input() checked = false;
  @Input() indeterminate = false;
  @Input() disabled = false;
  @Input() block = false;
  @Input() required = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  @ViewChild('input') private inputRef!: ElementRef<HTMLInputElement>;

  private onChangeFn: (value: boolean) => void = () => {};
  private onTouchedFn: () => void = () => {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['indeterminate'] && this.inputRef) {
      this.inputRef.nativeElement.indeterminate = this.indeterminate;
    }
  }

  ngAfterViewInit(): void {
    this.inputRef.nativeElement.indeterminate = this.indeterminate;
  }

  onInputChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.checked = checked;
    this.indeterminate = false;
    this.onChangeFn(checked);
    this.onTouchedFn();
    this.checkedChange.emit(checked);
  }

  writeValue(value: boolean): void {
    this.checked = !!value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
